import en from './en'
import es from './es'
import fr from './fr'
import ja from './ja'
import ko from './ko'
import ru from './ru'
import th from './th'
import vi from './vi'
import zhHans from './zh-Hans'
import zhHant from './zh-Hant'

export default {
  en,
  es,
  fr,
  ko,
  ja,
  ru,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
}
